import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Input, Button, Layout, Row, Col, List } from 'antd'

import AddEditRight from './AddEditRight'

@inject((store: any) => {
    const { popupStore, rightsStore, rightParamSetStore } = store
    return { popupStore, rightsStore, rightParamSetStore }
})
@observer
export default class RightsPopup extends Component<any, any> {
    state: any = {
        errors: {}
    }

    updateRightsList = async () => {
        const { rightsStore, popupStore, rightParamSetStore } = this.props
        await rightsStore.getRightsList({ right_param_set_id: popupStore.info.id })
        await rightsStore.resetFilters()
        await rightParamSetStore.getList()
    }

    closePopup = () => {
        this.props.rightsStore.resetRights()
        this.props.popupStore.togglePopup(false)
    }

    render() {
        const { popupStore, rightsStore } = this.props
        const { id, name } = popupStore.info
        const title =
            rightsStore.filteredList.length > 0
                ? `נמצאו ${rightsStore.filteredList.length} כיסויים`
                : 'לא נמצאו כיסויים'
        const footerButtons = (
            <div style={{ display: 'inline-block', width: '100%' }}>
                <Button onClick={this.closePopup}>סגור</Button>
            </div>
        )
        return (
            <Modal
                title={`עריכת זכויות בטבלה ${name} (${id})`}
                visible={popupStore.popupType === 'editRights'}
                cancelText="ביטול"
                width={600}
                bodyStyle={{ padding: '0.5rem 1.5rem' }}
                onCancel={this.closePopup}
                footer={footerButtons}
            >
                <label>
                    <strong style={{ fontSize: '1.1rem' }}>{title}</strong>
                </label>
                <Layout
                    style={{
                        display: 'flex',
                        width: '100%',
                        backgroundColor: 'white',
                        flexDirection: 'column',
                        padding: '0.5rem 0rem 0.8rem'
                    }}
                >
                    <Row>
                        <Col>
                            <Input.Search
                                name="filterRights"
                                placeholder="הזן טקסט לחיפוש הכיסוי"
                                value={rightsStore.filters['name']}
                                onChange={e => rightsStore.addFilter('name', e.target.value)}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <AddEditRight
                                right_param_set_id={popupStore.info.id}
                                rightUpdated={() => this.updateRightsList()}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <List
                                className="center-table"
                                style={{ width: '100%' }}
                                rowKey="id"
                                dataSource={rightsStore.filteredList}
                                pagination={{
                                    hideOnSinglePage: true,
                                    pageSize: 8
                                }}
                                renderItem={item => (
                                    <AddEditRight {...item} rightUpdated={() => this.updateRightsList()} />
                                )}
                            />
                        </Col>
                    </Row>
                </Layout>
            </Modal>
        )
    }
}
